@if (companyGroups.length) {
  <patron-form [formGroup]="authForm" (onSubmit)="changeCompanyGroup()">
    <div class="mb-3">
      <ng-select
        [items]="companyGroups"
        placeholder="Selecione o tipo de acesso / empresa"
        [ngClass]="{
          'is-invalid':
            authForm.get('company_group')?.dirty && authForm.get('company_group')?.invalid,
          'is-valid': authForm.get('company_group')?.dirty && authForm.get('company_group')?.valid,
        }"
        bindLabel="name"
        formControlName="company_group"
        (search)="selectSearchChanged($event)"
        [loading]="loadingSupportOptions"
        #cgSelect>
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-label">
            <span class="flex align-items-center">
              @if (item.access_type) {
                <patron-badge
                  [color]="patronUtils.getAccessTypeColor(item.access_type.key)"
                  class="mr-2">
                  {{ item.access_type.label }}
                </patron-badge>
              }
              <span>{{ item.displayName || item.name || item.alias }}</span>
              @if (item.block_code === 'SEM_LICENCA') {
                <patron-badge color="danger" class="ml-2">sem licença</patron-badge>
              } @else if (item.irregular || item.blocked) {
                <patron-badge color="danger" class="ml-2">irregular</patron-badge>
              }
            </span>
          </span>
          <span class="ng-value-icon right" (click)="clear(item)">×</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="flex align-items-center">
            @if (item.access_type) {
              <patron-badge
                [color]="patronUtils.getAccessTypeColor(item.access_type.key)"
                class="mr-2">
                {{ item.access_type.label }}
              </patron-badge>
            }
            <span>{{ item.displayName || item.name || item.alias }}</span>
          </span>
          <!-- Opção desabilitada precisa dizer por quê: sem o motivo, o cinza
               parece defeito do sistema, e não uma pendência a resolver. Para o
               suporte a linha continua clicável e o texto vira aviso: é assim
               que se enxerga quem está irregular antes de ligar o bloqueio. -->
          @if (item.disabled || item.irregular) {
            <small class="text-danger">
              @if (item.disabled && item.block_code === 'SEM_LICENCA') {
                {{ item.block_reason || 'Você não possui licença neste grupo empresa.' }}
              } @else if (item.disabled) {
                {{ item.block_reason || 'Cadastro irregular — entre em contato com a Teorema.' }}
              } @else {
                Cadastro irregular na base da Teorema
              }
            </small>
          }
        </ng-template>
        @if (user.enable_support && !isSupportOptionsLoaded) {
          <ng-template ng-footer-tmp>
            <div class="py-2 px-3">
              <patron-button
                customClass="flex justify-content-center w-full"
                size="sm"
                iconName="bi-wrench"
                [loading]="loadingSupportOptions"
                (click)="loadSupportOptions()">
                Acessos de suporte
              </patron-button>
            </div>
          </ng-template>
        }
      </ng-select>
    </div>
    <patron-button
      type="submit"
      [loading]="loading"
      customStyle="width: 100%"
      customClass="flex justify-content-center"
      class="w-full"
      iconName="bi-box-arrow-in-right">
      {{ submitButtonText }}
    </patron-button>
  </patron-form>
}
